export default "__VITE_PUBLIC_ASSET__552147b3__"